import { isPreviewRelease } from "../../appConfig";

export const getBizEntityUrlPrefix = () => (isPreviewRelease ? "/api/preview/bizEntity" : "/api/bizEntity");

export const getUserServiceUrlPrefix = () => (isPreviewRelease ? "/api/preview/userService" : "/api/userService");

export const getPickerUrlPrefix = () => (isPreviewRelease ? "/api/preview/picker" : "/api/picker");

export const getDashboardsUrlPrefix = () => (isPreviewRelease ? "/api/preview/dashboards" : "/api/dashboards");
